import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DbTemplateInfo, DbObjectTypeEnum } from '../db-template.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-db-template-properties',
    templateUrl: './db-template-properties.component.html',
    styleUrl: './db-template-properties.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class DbTemplatePropertiesComponent {

    @Input() DbTemplateInfo!: DbTemplateInfo;
    @Input() postProcessChoicesWrite: string[] = [];
    @Input() postProcessChoicesDelete: string[] = [];
  
    public dbObjectTypeEnum = DbObjectTypeEnum;
  constructor(
    public activeModal: NgbActiveModal
  ) { }

}
